import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Constants from "../../Constants";
import APIUrls from "../../services/APIUrls";
import Papa from 'papaparse';
import { UploadIcon, ZipfileIcon } from "../../AppIcons";
import CustomProgressBar from "../../components/global/CustomProgressBar";
import { ConditionalBlock } from '../../ConditionalBlock';
import { putAxiosResponse } from "../../services/authApiRoutes/APImethods";
import moment from 'moment';

export default function ImportBulkProject(prop) {
  const { t } = useTranslation();
  const [fileName, setFileName] = useState("");
  const [showError, setShowError] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState([]);
  const [data, setData] = useState([]);
  const [totalChunks, setTotalChunks] = useState(0);
  const [showProgress, setShowProgress] = useState(false);
  const chunk = Constants.FINANCE_PROJECT_CHUNK_SIZE;
  const specialCharPattern = /^[a-zA-Z0-9\/\-\ ]*$/;
  const expectedTemplateHeaders = ['PROJECT_ID', 'CUSTOMER_INVOICE_STATUS', 'CUSTOMER_INVOICE_NO', 'SUPPLIER_INVOICE_STATUS', 'SUPPLIER_INVOICE_NO', 'CUSTOMER_PAID_DATE'];
  const optionalHeaders = ['CUSTOMER_INVOICE_STATUS', 'CUSTOMER_INVOICE_NO', 'SUPPLIER_INVOICE_STATUS', 'SUPPLIER_INVOICE_NO', 'CUSTOMER_PAID_DATE'];
  const customerBillingStatus = [t("subscriber_invoice_status.CUSTOMER_INVOICE_NO_ACTION"), t("subscriber_invoice_status.CUSTOMER_INVOICE_SENT"), t("subscriber_invoice_status.CUSTOMER_INVOICE_PAID")];
  const vendorBillingStatus = [t("service_provider_invoice_status.VENDOR_INVOICE_NO_ACTION"), t("service_provider_invoice_status.VENDOR_INVOICE_RECEIVED"), t("service_provider_invoice_status.VENDOR_INVOICE_PAID"),t("finance.vendor_awaiting_invoice_status")];

  const invalidIndexObjects = () => {
    const customerInvalidStatusPID = [];
    const vendorInvalidStatusPID = [];
    const customerInvoiceInvalidPID = [];
    const supplierInvoiceInvalidPID = [];
    const customerInvoiceNumberInvalidLengthPID = [];
    const supplierInvoiceNumberInvalidLengthPID = [];
    const noPID = [];
    const projectIds = [];
    const customerPaidDateInvalidPID = [];
    return { customerInvalidStatusPID, vendorInvalidStatusPID, customerInvoiceInvalidPID, supplierInvoiceInvalidPID, noPID, projectIds, customerPaidDateInvalidPID, customerInvoiceNumberInvalidLengthPID, supplierInvoiceNumberInvalidLengthPID };
  }

  const checkInvalidStatusAndInvoiceNum = (rows) => {
    let errorMsg = [];
    const error = invalidIndexObjects();
    const seen = new Set();
    const duplicates = new Set();

    rows.forEach((row, index) => {
      if (row.PROJECT_ID) {
        row.CUSTOMER_INVOICE_STATUS && !customerBillingStatus.includes(row.CUSTOMER_INVOICE_STATUS) && error.customerInvalidStatusPID.push(row.PROJECT_ID);
        row.SUPPLIER_INVOICE_STATUS && !vendorBillingStatus.includes(row.SUPPLIER_INVOICE_STATUS) && error.vendorInvalidStatusPID.push(row.PROJECT_ID);
        row.CUSTOMER_INVOICE_NO && !specialCharPattern.test(row.CUSTOMER_INVOICE_NO) && error.customerInvoiceInvalidPID.push(row.PROJECT_ID);
        row.CUSTOMER_INVOICE_NO && row.CUSTOMER_INVOICE_NO.length > 32 && error.customerInvoiceNumberInvalidLengthPID.push(row.PROJECT_ID);
        row.SUPPLIER_INVOICE_NO && !specialCharPattern.test(row.SUPPLIER_INVOICE_NO) && error.supplierInvoiceInvalidPID.push(row.PROJECT_ID);
        row.SUPPLIER_INVOICE_NO && row.SUPPLIER_INVOICE_NO.length > 32 && error.supplierInvoiceNumberInvalidLengthPID.push(row.PROJECT_ID);
        row.PROJECT_ID && error.projectIds.push(row.PROJECT_ID);
        row.CUSTOMER_PAID_DATE && !moment(row.CUSTOMER_PAID_DATE, ['MM/DD/YY', 'MM/DD/YYYY'], true).isValid() && error.customerPaidDateInvalidPID.push(row.PROJECT_ID);
      } else {
        error.noPID.push(index + 2)
      };
    });

    error.projectIds.forEach(value => {
      if (seen.has(value)) {
        duplicates.add(value);
      } else {
        seen.add(value);
      }
    });

    if (error.customerInvoiceInvalidPID.length > 0) {
      errorMsg.push(t("finance.invalid_customer_invoice").concat(error.customerInvoiceInvalidPID.join(', ')));
    }
    if(error.customerInvoiceNumberInvalidLengthPID.length > 0) {
      errorMsg.push(t("finance.invalid_length_customer_invoice").concat(error.customerInvoiceNumberInvalidLengthPID.join(', ')));
    }
    if (error.supplierInvoiceInvalidPID.length > 0) {
      errorMsg.push(t("finance.invalid_vendor_invoice").concat(error.supplierInvoiceInvalidPID.join(', ')));
    }
    if(error.supplierInvoiceNumberInvalidLengthPID.length > 0) {
      errorMsg.push(t("finance.invalid_length_vendor_invoice").concat(error.supplierInvoiceNumberInvalidLengthPID.join(', ')));
    }
    if (error.customerInvalidStatusPID.length > 0) {
      errorMsg.push(t("finance.invalid_customer_invoice_status").concat(error.customerInvalidStatusPID.join(', ')));
    }
    if (error.vendorInvalidStatusPID.length > 0) {
      errorMsg.push(t("finance.invalid_vendor_invoice_status").concat(error.vendorInvalidStatusPID.join(', ')));
    }
    if (duplicates.size > 0) {
      errorMsg.push(t("finance.duplicate_projectsIDs").concat(Array.from(duplicates).join(', ')));
    }
    if (error.noPID.length > 0) {
      errorMsg.push(t("finance.no_project_id_found").concat(error.noPID.join(', ')));
    }
    if (error.customerPaidDateInvalidPID.length > 0) {
      errorMsg.push(t("finance.invalid_customer_paid_date").concat(error.customerPaidDateInvalidPID.join(', ')));
    }

    seen.clear();
    duplicates.clear();
    delete error.customerInvoiceInvalidPID;
    delete error.supplierInvoiceInvalidPID;
    delete error.customerInvalidStatusPID;
    delete error.vendorInvalidStatusPID;
    delete error.projectIds;
    delete error.noPID;


    return errorMsg;
  };



  const parseFile = (files) => {
    if (files) {
      Papa.parse(files, {
        header: true,
        dynamicTyping: false,
        skipEmptyLines: 'greedy',
        complete: (results) => {
          const headings = results.meta.fields
          const rows = results.data;

          let errorMsg = checkInvalidStatusAndInvoiceNum(rows);

          const missingHeaders = optionalHeaders.filter(value => !headings.includes(value));

          if ( !headings.includes('PROJECT_ID')) {
            errorMsg.push( t("finance.invalid_file_header"));
          }

          if(missingHeaders.length == optionalHeaders.length) {
            errorMsg.push(t("finance.no_data_found"));
          }

          if (errorMsg.length > 0) {
            setShowError(true);
            setErrorMessage(errorMsg);
          } else {
            setData(rows);
          }

        },
        error: (error) => {
          setErrorMessage([`Parsing Error: ${error}`]);
        }
      });
    }
  };

  useEffect(() => {
    if (data.length > 0 && showProgress) {
      let uploadedData = data.splice(0, chunk);
      uploadChunks(uploadedData);
    }
  }, [showProgress, totalChunks]);


  const uploadChunks = (uploadedData) => {
    putAxiosResponse(APIUrls.PROJECT_FINANCE_DATA_UPLOAD, uploadedData).then((res) => {
      setTimeout(function () {
        setData(data.filter(item => !uploadedData.includes(item)));
        setTotalChunks(Math.ceil(data.length / chunk));
        if (data.length === 0) {
          setShowProgress(false);
          prop.setShowSuccess(true);
          prop.setShowBulkImport(false);
          setFileName();
        }
      }, 1000);
    }).catch((err) => {
      setErrorMessage([`some exception occurred while uploading data`]);
    });
  };


  const handleFileChange = (e) => {
    if (e.target && e.target.files && e.target.files.length > 0) {
      setFileName(e.target.files[0].name);
      parseFile(e.target.files[0]);
      setShowError(false);
      setShowSuccess(false);
      setErrorMessage([]);
    }
  };

  const handleUploadClick = (e) => {
    if (!fileName || data.length === 0) {
      return;
    } else {
      setShowProgress(true);
    }
  };

  const downloadBulkUserTemplate = () => {
    const config = { delimiter: ',' };
    var csv = Papa.unparse({
      fields: expectedTemplateHeaders,
      data: [
        {
          "PROJECT_ID": "1",
          "CUSTOMER_INVOICE_STATUS": t("subscriber_invoice_status.CUSTOMER_INVOICE_NO_ACTION"),
          "CUSTOMER_INVOICE_NO": "242xx",
          "SUPPLIER_INVOICE_STATUS": t("service_provider_invoice_status.VENDOR_INVOICE_NO_ACTION")+" / "+t("finance.vendor_awaiting_invoice_status"),
          "SUPPLIER_INVOICE_NO": "37qqw",
          "CUSTOMER_PAID_DATE": "MM/DD/YY"
        },
        {
          "PROJECT_ID": "12",
          "CUSTOMER_INVOICE_STATUS": t("subscriber_invoice_status.CUSTOMER_INVOICE_SENT"),
          "CUSTOMER_INVOICE_NO": "242xx",
          "SUPPLIER_INVOICE_STATUS": t("service_provider_invoice_status.VENDOR_INVOICE_RECEIVED"),
          "SUPPLIER_INVOICE_NO": "37qqw",
          "CUSTOMER_PAID_DATE": "MM/DD/YY"
        },
        {
          "PROJECT_ID": "123",
          "CUSTOMER_INVOICE_STATUS": t("subscriber_invoice_status.CUSTOMER_INVOICE_PAID"),
          "CUSTOMER_INVOICE_NO": "242xx",
          "SUPPLIER_INVOICE_STATUS": t("service_provider_invoice_status.VENDOR_INVOICE_PAID"),
          "SUPPLIER_INVOICE_NO": "37qqw",
          "CUSTOMER_PAID_DATE": "MM/DD/YY"
        }
      ],
      config
    });
    var csvData = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const href = URL.createObjectURL(csvData);
    const link = document.createElement('a');
    link.href = href;
    link.setAttribute('download', 'IMPORT_BULK_PROJECT_TEMPLATE.csv');
    document.body.appendChild(link);
    link.click()
    document.body.removeChild(link);
    URL.revokeObjectURL(href);
  };


  const downloadBulkUserTemplateKeyDown = (e) => {
    if (e.key === Constants.ENTER) {
      downloadBulkUserTemplate();
    }
  };

  const cancelBulkUpload = () => {
    prop.setShowBulkImport(false);
    setFileName();
    setData([]);
    setShowError(false);
    setShowSuccess(false);
    setErrorMessage([]);
    prop.setRetainFilter(true);
  }

  const cancelBulkUploadOnKeyDown = (event) => {
    if (event.key === Constants.ENTER) {
      cancelBulkUpload();
    }
  }

  function handleDrop(e) {
    e.preventDefault();
    if (e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      let name = e.dataTransfer.files[0].name;
      const extension = name.split('.').pop().toLowerCase();
      if (extension !== 'csv') {
        setShowError(true);
        setErrorMessage([t("finance.finance_invalid_file_upload")]);
        return;
      }
      setFileName(name);
      parseFile(e.dataTransfer.files[0]);
      setShowError(false);
      setShowSuccess(false);
      setErrorMessage([]);
    }
  }

  return (
    <div className="step-1-section importbulk-section">
      <div className="upload-file-block">
        <h3>{`${t('finance.finance_user_bulk_project_detail')}`}</h3>

        <div className="upload-file-container" onDragOver={(e) => { e.preventDefault(); }} onDragLeave={(e) => { e.preventDefault(); }}
          onDrop={(e) => handleDrop(e)}>
          <div className="upload-icon">
            {UploadIcon}
          </div>
          <div className="upload-format">
            {`${t('finance.finance_user_bulk_project_detail_import_upload_csv')}`}
            &nbsp;<a tabIndex={0} onClick={downloadBulkUserTemplate} onKeyDown={(e) => downloadBulkUserTemplateKeyDown(e)} aria-label="Import bulk project template">{`${t('finance.finance_user_bulk_project_detail_template_link')}`}</a>
          </div>
          <div className="file-drag">{`${t('upload_drag_drop_files_here')}`}</div>
          <div className="input-file-container">
            <div className="input-file">
              <input
                type="file"
                id="files"
                accept=".csv"
                tabIndex={0}
                onChange={handleFileChange}
              />
              <label className="file-button" htmlFor="files">
                {`${t('choose_file')}`}
              </label>
            </div>
            <div className="upload-file-ext flex-center">
              <div className="inline-flex">
                <strong className={fileName ? "show-flex" : "hide"}>
                  {ZipfileIcon}
                </strong>
                <span>{fileName}</span>
              </div>
            </div>

            <ConditionalBlock condition={showProgress}>
              <div className="right-progressbar">
                <label className="name">{fileName}</label>
                <CustomProgressBar
                  completed={totalChunks !== 0 ? Math.ceil(100 / totalChunks) : 0}
                  labelSize="14px"
                  width="100%"
                  labelClassName="progressBarLabel"
                  borderRadius="30px"
                  labelAlignment="outside"
                  labelLineHeight="1px"
                  labelColor="rgba(0,0,0,0.87)"
                  height="6px"
                  className="campaign_progress"
                  bgColor="#06B878"
                  baseBgColor="#D1DEF0"
                  ariaValuetext={totalChunks !== 0 ? Math.ceil(100 / totalChunks) : 0}
                  aria-label=""
                  aria-valuenow={totalChunks !== 0 ? Math.ceil(100 / totalChunks) : 0}
                />
              </div>

            </ConditionalBlock>
            <div className={"error upload-error finance-upload-error" + (showError === true ? " show" : " hide")} id="show-error" role="alert">
              {errorMessage.map((msg, index) => (
                <div className="mar-bot20" key={index}>{msg}</div>
              ))}
            </div>
            <div className={"success-message" + (showSuccess === true ? " show" : " hide")} id="show-success" role="alert">
              {`${t('finance.bulk_project_upload_success')}`}
            </div>
            <button
              aria-label="Upload"
              className="btn"
              onClick={handleUploadClick}
              disabled={errorMessage.length > 0}
            >
              {`${t('button_upload')}`}
            </button>
          </div>
        </div>
      </div>
      <div className="stricy-btn flex flex-center no-rightlist justify-end">
        <div className="left flex">
          <div>
            <button aria-label="back" className="btn-default" onClick={cancelBulkUpload} onKeyDown={(e) => cancelBulkUploadOnKeyDown(e)}>{`${t('button_back')}`}</button>
          </div>
        </div>
      </div>
    </div>
  );
}
